import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { CastCache } from '@xanadu/cache';
import { PanelComponent, Register } from '@xanadu/core';
import { Cast, Notice, NoticeType } from '@xanadu/model';

@Component({
    selector: 'app-cast-panel',
    templateUrl: './cast-panel.component.html',
    styleUrls: ['./cast-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('cast-panel')
export class CastPanelComponent extends PanelComponent<Cast> {
    private readonly castCache = inject(CastCache);

    private tabCast = { caption: 'Cast', active: true, hidden: false };

    public metaExpansionScript: any = { title: 'JavaScript', description: 'JavaScript casting funcation' };

    protected override get nodeType(): string | undefined {
        return 'import';
    }

    constructor() {
        super();

        const infoSave = new Notice();
        infoSave.type = NoticeType.Info;

        effect(() => {
            const model = this.model();

            const custome = model.custome;
            if (!!custome) {
                custome.expansionScript = custome.expansionScript || { expanded: true };
            }
        });
    }

    protected override setup(cast: Cast): void {
        super.setup(cast);
        this.tabs = [
            this.tabCast
        ];
        this.tabSelected = this.tabCast;
    }

    protected override refresh(cast: Cast): void {
        super.refresh(cast);

        this.castCache.update();
    }

    protected override load(cast: Cast, form: any): string | undefined {
        super.load(cast, form);

        cast.data = form;
        return;
    }
}
